// extracted by mini-css-extract-plugin
module.exports = {"position":"styles_position__sv8Uz"};